export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/live_action_explainers.232994f.svg";